module.exports = __webpack_public_path__ + "static/media/movie01.34e2f8f2.jpg";